module.exports = __webpack_public_path__ + "img/jelena-poljicanin.b9d003b3.jpg";